import request from '@/utils/request';
// 面板列表
export function panelList(data) {
  return request.post('admin/panel/list', data);
}
// 面板详情
export function panelDetail(data) {
  return request.post('admin/panel/detail', data);
}
// 面板新增
export function addPanel(data) {
  return request.post('admin/panel/store', data);
}
// 面板编辑
export function editPanel(data) {
  return request.post('admin/panel/edit', data);
}
// 面板删除
export function delPanel(data) {
  return request.post('admin/panel/delete', data);
}